<div class="wrapper-menu">
  <div class="logo">
    <div class="logo-main">
      <img src="assets/logo-skideo-text.png" />
    </div>
  </div>
  <ul class="menu-main">
    <li>
      <a routerLink="/dashboard" routerLinkActive="active">
        <span class="menu-item-icon">
          <i class="icon-dashboard"></i>
        </span>
        <span class="menu-title" i18n>Dashboard</span>
      </a>
    </li>
    <li>
      <a routerLink="/templates" routerLinkActive="active">
        <span class="icon-layers menu-item-icon"> </span>
        <span class="menu-title" i18n>Templates</span>
      </a>
    </li>
    @if (builderCount && builderCount > 0) {
      <li>
        <a routerLink="/builder" routerLinkActive="active">
          <span class="menu-item-icon">
            <i class="fa-solid fa-grid"></i>
          </span>
          <span class="menu-title" i18n>Builder</span>
        </a>
      </li>
    }
    <li>
      <a routerLink="/content" routerLinkActive="active">
        <span class="menu-item-icon">
          <i class="far fa-play-circle"></i>
        </span>
        <span class="menu-title" i18n>Content</span>
      </a>
    </li>
    <li>
      <a routerLink="/reports" routerLinkActive="active">
        <span class="menu-item-icon">
          <i class="far fa-chart-line"></i>
        </span>
        <span class="menu-title" i18n>Reports</span>
      </a>
    </li>
    <li>
      <a routerLink="/users" routerLinkActive="active">
        <a routerLink="/create-user" routerLinkActive="active" style="display: none"></a>
        <a routerLink="/edit-user" routerLinkActive="active" style="display: none"></a>
        <a routerLink="/user" routerLinkActive="active" style="display: none"></a>
        <span class="icon-user_circle menu-item-icon"> </span>
        <span class="menu-title" i18n>Users</span>
      </a>
    </li>
  </ul>
</div>
